module.exports = "/_next/static/files/33c208dcfead38c77d2e22ded2a2c22a.jpg";